module.exports = __webpack_public_path__ + "img/blog-advertising.fcd15e67.jpg";